<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-align-center">
  <input #inputText [formControl]="control" matInput class="mat-input-element ag-input-field-input" type="text"
    (focusout)="onFocusOut()"
    (focusin)="fullRowEdit && inputText.select()"
    [matAutocomplete]="auto"/> @if (suffix) {
    <span>{{suffix}}</span>
  }
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected()">
    @for (fieldValue of filteredSuggestions | async; track fieldValue) {
      <mat-option
      [value]="fieldValue">{{ fieldValue }}</mat-option>
    }
  </mat-autocomplete>

  @if (control.invalid) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon" [matTooltip]="errorTooltip"></mat-icon>
    </div>
  }
  @if (control.pending) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-loading" class="mdi-spin loading tooltip-icon"></mat-icon>
    </div>
  }
  @if (!fullRowEdit) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-check" (click)="stopEditing()"></mat-icon>
    </div>
  }
</div>
